import { render, staticRenderFns } from "./userTag.vue?vue&type=template&id=beb1f156&scoped=true&"
import script from "./userTag.vue?vue&type=script&lang=js&"
export * from "./userTag.vue?vue&type=script&lang=js&"
import style0 from "./userTag.vue?vue&type=style&index=0&id=beb1f156&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb1f156",
  null
  
)

export default component.exports